import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // Remove all MUI elevation shadows globally
  shadows: Array(25).fill('none') as any,
  palette: {
    primary: {
      main: '#0043FE',
      light: '#4D7BFF',
      dark: '#0036CB',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: '#fff',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350',
      dark: '#c62828',
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    info: {
      main: '#0288d1',
      light: '#03a9f4',
      dark: '#01579b',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      'Manrope',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
          borderRadius: 4,
        },
        containedPrimary: {
          backgroundColor: '#0043FE',
          '&:hover': { backgroundColor: '#0039E6' },
          boxShadow: 'none',
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #eaeaea',
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    // Restore subtle shadows for toggle-style components
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        },
        track: {
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0,0,0,0.22)',
          },
          '&.Mui-selected': {
            boxShadow: '0 2px 6px rgba(0,0,0,0.24)',
          },
        },
      },
    },
  },
});

export default theme;
